import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Sync} from '@client/sync'
import {Tracking, TrackingEvent} from '@common/tracking'
import {OptionsItem} from '@components/common/base/dropdown-button-menu/types'
import {SelectWithDropdown} from '@components/common/base/select-with-dropdown/select-with-dropdown'
import {globals} from '@extensions/globals-base'
import {pendingCompanyUserStore} from '../../logged-in/pending-company-user-store'
import {profilePage} from '../constants'
import {changeCompany, goto} from '../handlers/main-handlers'
import {useMainMenuStore} from '../main-menu-store'

const TwContainer = tw.div`
  mt-auto
  pt-16
  px-12
  space-y-8
`
const TwCaption = tw.div`
  text-14
  leading-4
  text-panel-text-primary
`

const TwHint = tw.div`
  mt-4
  text-panel-text-primary
  text-12
  leading-4
`

export const CompanyListMenuItem = observer(() => {
  const [state] = useMainMenuStore()
  const currentCompanyId = globals.getCompanyId()

  const {companies, newMsgInOtherCompanies} = state
  const unseen = newMsgInOtherCompanies > 0

  const pendingCompanies = Sync.getPendingCompanies()

  useEffect(() => {
    pendingCompanyUserStore.state.modified
  }, [pendingCompanyUserStore.state.modified])

  if ([...companies, ...pendingCompanies].length < 2) {
    return null
  }

  const options: OptionsItem[] = companies.map(company => {
    const {id, name: text, newMsg} = company
    return {
      key: id,
      text,
      selected: currentCompanyId === id,
      cb: () => {
        changeCompany(id)
        void Tracking.send(TrackingEvent.leftPanelChangeCompanyClick)
      },
      count: newMsg ? String(newMsg) : '',
      highlightNumber: true
    }
  })

  for (const company of pendingCompanies) {
    const {companyId: id, companyName: text} = company
    options.push({
      key: id,
      text,
      selected: false,
      cb: () => {
        pendingCompanyUserStore.update()
      },
      count: '',
      highlightNumber: false
    })
  }

  const currentCompanyTitle = options.find(o => o.selected)?.text || ''

  options.unshift({
    key: 'companiesSettings',
    text: Lang.msg.menu.companiesSettings,
    cb: () => {
      goto(profilePage)
      void Tracking.send(TrackingEvent.leftPanelCompaniesSettingsClick)
    }
  })

  return (
    <TwContainer>
      <TwCaption>{Lang.msg.changeCompanyLabel}</TwCaption>
      <SelectWithDropdown
        options={options}
        value={currentCompanyTitle}
        withNumbers
        variant="panel"
        error={unseen}
      />
      {unseen && (
        <TwHint>
          {Lang.msg.newMsgInOtherCompanies} ({newMsgInOtherCompanies})
        </TwHint>
      )}
    </TwContainer>
  )
})
